import localAxios from '../localAxios';
import { QuestionResponse } from './generateQuestions';
import { getJobStatusUrl } from './urls';

export interface AiJobStatusResponse {
  type?: string;
  publicId?: string;
  aiRequestId?: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  startTime?: number;
  data?: {
    questions?: QuestionResponse[];
    questionCount?: number;
    version?: string;
    promptVersion?: string;
    elapsedTime?: number;
    usage?: {
      promptTokens: number;
      completionTokens: number;
      totalTokens: number;
    };
  };
  error?: string;
}

export async function getJobStatus(
  requestId: string
): Promise<AiJobStatusResponse> {
  const url = getJobStatusUrl(requestId);

  try {
    const { data } = await localAxios.get<AiJobStatusResponse>(url.href);
    return data;
  } catch (error: any) {
    // Handle 404 as pending status
    if (error?.response?.status === 404) {
      return { status: 'pending' };
    }
    throw error;
  }
}
